import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, ArrowDownIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const painPoints = ['Si en invierno o época de lluvia tu negocio prácticamente para', 'Si tienes equipos y empleados pero no suficiente trabajo para mantenerlos', 'Si la mayoría de tus clientes son "de una sola vez" y no contratos de mantenimiento recurrente', 'Si compites con "el vecino que tiene una podadora" y no sabes cómo diferenciarte', 'Si gastas en Facebook Ads y solo te llaman para preguntar el precio y desaparecen'];
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col justify-center px-6 py-12 md:py-20 overflow-hidden" data-id="element-153">
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-154" />

      <div className="max-w-7xl w-full mx-auto relative z-10" data-id="element-155">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-156">
          {/* Left Column: Text & Bullets */}
          <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-col" data-id="element-157">
            <motion.div variants={itemVariants} className="mb-8" data-id="element-158">
              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6 text-balance" data-id="element-159">
                ¿Tu negocio de <span className="text-gold" data-id="element-160">Landscaping</span>{' '}
                solo crece cuando hace buen tiempo?
              </h1>

              <div className="space-y-4" data-id="element-161">
                <p className="text-lg md:text-xl text-neutral-300 font-body leading-relaxed" data-id="element-162">
                  Instalamos un sistema que te trae contratos de mantenimiento
                  mensual recurrente para que tu facturación sea predecible los
                  12 meses del año.
                </p>
                <p className="text-xl md:text-2xl text-gold font-semibold font-heading" data-id="element-163">
                  Sin depender de la temporada. Sin depender del clima.
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-carbon-light border border-carbon-lighter rounded-2xl p-6 mb-10 shadow-xl" data-id="element-164">
              <ul className="space-y-4" data-id="element-165">
                {painPoints.map((point, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-3" data-id="element-166">
                    <XCircleIcon className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-167" />
                    <span className="text-neutral-300 font-body text-base leading-snug" data-id="element-168">
                      {point}
                    </span>
                  </motion.li>)}
              </ul>
            </motion.div>

            <motion.div variants={itemVariants} className="flex flex-col items-start" data-id="element-169">
              <a href="#contact-form" className="group relative inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-dark text-carbon font-heading font-bold text-lg md:text-xl px-8 py-5 rounded-xl transition-all duration-300 animate-cta-glow hover:scale-105 active:scale-95 w-full md:w-auto text-center" data-id="element-170">
                <span data-id="element-171">QUIERO CONTRATOS RECURRENTES</span>
                <ArrowDownIcon className="w-5 h-5 group-hover:translate-y-1 transition-transform" data-id="element-172" />
              </a>

              <div className="mt-6 text-center md:text-left w-full md:w-auto" data-id="element-173">
                <p className="text-neutral-400 font-body text-sm mb-2" data-id="element-174">
                  Diagnóstico gratuito en 15 minutos.
                </p>
                <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold-dark underline underline-offset-4 font-body text-sm transition-colors" data-id="element-175">
                  O haz tu cita directamente en nuestro calendario aquí
                </a>
              </div>
            </motion.div>
          </motion.div>

          {/* Right Column: Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="relative h-[400px] md:h-[500px] lg:h-[700px] w-full rounded-2xl overflow-hidden border border-carbon-lighter shadow-2xl" data-id="element-176">
            <div className="absolute inset-0 bg-gradient-to-t from-carbon via-transparent to-transparent z-10 opacity-60" data-id="element-177" />
            <img src="https://cdn.magicpatterns.com/uploads/ioQNcY1gMopTTtvdEbP3tA/heylloyd-image-1773433496641.png" alt="Profesional de Landscaping trabajando" className="w-full h-full object-cover object-center" data-id="element-178" />
          </motion.div>
        </div>
      </div>
    </section>;
}